<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('automod')">Automoderation</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.type" class="pr-6 pb-8 w-full lg:w-1/2" label="Automoderation to perform">
            <option value="ban">Ban User</option>
            <option value="timeout">Timeout User</option>
            <option value="delete">Delete Message</option>
          </select-input>
          <template v-if="form.type=='timeout'">
            <text-input v-model="form.duration" class="pr-6 pb-8 w-full lg:w-1/2" label="Duration (in sec)" />
          </template>
          <template v-else>
            <input class="pr-6 pb-8 w-full lg:w-1/2" />
          </template>
          <text-input v-model="form.term" class="pr-6 pb-8 w-full lg:w-1/2" label="Term" />
          <select-input v-model="form.is_enabled" class="pr-6 pb-8 w-full lg:w-1/2" label="Is Enabled">
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select-input>
          <textarea-input v-model="form.reason" class="pr-6 pb-8 w-full" label="Moderation Reason (for logs and user)" :error="this.$page.props.errors.reason"/>
              <!--
              <text-input v-model="form.stream_title_hashtag" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Hashtags" rows="4" max-rows="6"/>
              <text-input v-model="form.stream_tags" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Tags" rows="4" max-rows="6"/>
              <text-input v-model="form.stream_game" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Game" />
              -->

            </div>
            <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
              <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create </loading-button>
            </div>
          </form>
        </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '../../Shared/TextareaInput.vue'

export default {
  metaInfo: { title: 'Create Automoderation' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        term: null,
        type: "timeout",
        duration: "30",
        reason: null,
        stream_title_hashtag: null,
        stream_tags: null,
        stream_game: null,
        is_enabled: 1,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('automod.store'))
    },
    update() {
      this.form.put(this.route('automod.update', this.automod.id))
    },
  },
}
</script>
